import { Component, Host, h, Prop } from '@stencil/core';
import { generateAnchorAttributes, openURL } from '../../utils/elements-interface';
export class RouterLink {
  constructor() {
    /**
     * HTML <a> target attribute
     */
    this.target = '_blank';
    this.onClick = (ev) => {
      openURL(this.href, ev);
    };
  }
  render() {
    const AnchorTag = this.stretchedLink ? 'sy-stretched-link' : 'a';
    return (h(Host, { onClick: this.onClick },
      h(AnchorTag, Object.assign({}, generateAnchorAttributes(this)),
        h("slot", null))));
  }
  static get is() { return "sy-router-link"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() { return {
    "$": ["scss/index.scss"]
  }; }
  static get styleUrls() { return {
    "$": ["./scss/index.css"]
  }; }
  static get properties() { return {
    "download": {
      "type": "string",
      "mutable": false,
      "complexType": {
        "original": "string | undefined",
        "resolved": "string",
        "references": {}
      },
      "required": false,
      "optional": false,
      "docs": {
        "tags": [],
        "text": "HTML <a> download attribute"
      },
      "attribute": "download",
      "reflect": false
    },
    "href": {
      "type": "string",
      "mutable": false,
      "complexType": {
        "original": "string | undefined",
        "resolved": "string",
        "references": {}
      },
      "required": false,
      "optional": false,
      "docs": {
        "tags": [],
        "text": "HTML <a> href attribute"
      },
      "attribute": "href",
      "reflect": false
    },
    "rel": {
      "type": "string",
      "mutable": false,
      "complexType": {
        "original": "string | undefined",
        "resolved": "string",
        "references": {}
      },
      "required": false,
      "optional": false,
      "docs": {
        "tags": [],
        "text": "HTML <a> rel attribute"
      },
      "attribute": "rel",
      "reflect": false
    },
    "target": {
      "type": "string",
      "mutable": false,
      "complexType": {
        "original": "'_blank' | '_self' | '_parent' | '_top'",
        "resolved": "\"_blank\" | \"_parent\" | \"_self\" | \"_top\"",
        "references": {}
      },
      "required": false,
      "optional": false,
      "docs": {
        "tags": [],
        "text": "HTML <a> target attribute"
      },
      "attribute": "target",
      "reflect": false,
      "defaultValue": "'_blank'"
    },
    "stretchedLink": {
      "type": "boolean",
      "mutable": false,
      "complexType": {
        "original": "false",
        "resolved": "boolean",
        "references": {}
      },
      "required": false,
      "optional": false,
      "docs": {
        "tags": [],
        "text": "Defines whether the link should be stretched"
      },
      "attribute": "stretched-link",
      "reflect": true
    }
  }; }
}
